// extracted by mini-css-extract-plugin
export default {"logoText":"SignIn_logoText__L1hJV","braincellsLogo":"SignIn_braincellsLogo__9TPFV","bgBubbles":"SignIn_bgBubbles__ZEMBu","square":"SignIn_square__4A4am"};